import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  listItem: {
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    flexWrap: "wrap",
    fontSize: "14px",
    marginBottom: "16px",
  },
  dd: {
    marginLeft: 0,
  },
  dt: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  title: {
    fontSize: "14px",
    color: "#21242c",
    fontWeight: 600,
  },
  subtitle: {
    fontSize: "12px",
    color: "#676f7e",
  },
}));

const ServiceResume = (props) => {
  const { title, subtitle, price } = props;
  const classes = useStyles();
  return (
    <li className={classes.listItem}>
      <dt className={classes.dt}>
        <span className={classes.title}>{title}</span>
        {subtitle && <span className={classes.subtitle}>{subtitle}</span>}
      </dt>
      {price && (
        <dd className={classes.dd}>
          <span className={classes.title}>{price}</span>
        </dd>
      )}
    </li>
  );
};

export default ServiceResume;
